export default "__VITE_ASSET__BGRXD2QH__"